var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleArrowinline = function SvgCircleArrowinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    width: 32,
    height: 32,
    rx: 16,
    transform: "matrix(-1 0 0 1 32 .2)",
    fill: "inherit"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.856 12.113c-.546-.63-.497-1.6.11-2.167a1.439 1.439 0 0 1 2.085.114l4.431 5.113a1.578 1.578 0 0 1 0 2.052l-4.43 5.112a1.44 1.44 0 0 1-2.087.114 1.575 1.575 0 0 1-.11-2.166l3.542-4.086-3.541-4.087Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.615 17.677h12.554a1.477 1.477 0 1 0 0-2.954H8.615a1.477 1.477 0 1 0 0 2.954Z",
    fill: "#fff"
  })));
};
export default SvgCircleArrowinline;